module.exports = __webpack_public_path__ + "images/emoji/thumbsdown.5a9b5d4ca21a3d76963d.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/emoji/thumbsdown.png
// module id = LvuR
// module chunks = 14